var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('app-bar'),_c('div',{staticClass:"wrapper__inner"},[_c('router-view')],1),_c('app-footer')],1),_vm._l((_vm.components),function(item){return _c(item.component,{key:item.id,tag:"components"})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }